import { useId, type ReactNode } from 'react'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  type FormControlProps,
  type SelectProps,
} from '@mui/material'

export type DropdownProps = Omit<SelectProps, 'variant'> & {
  formControlProps?: Omit<FormControlProps, 'error' | 'fullWidth' | 'size' | 'variant'>
  helperText?: ReactNode
  label?: ReactNode
}

export function Dropdown({ children, error = false, formControlProps, fullWidth = true, helperText, label, size = 'medium', ...props }: DropdownProps) {
  const fallbackId = useId()
  const labelId = props.labelId ?? `${fallbackId}-label`

  return (
    <FormControl {...formControlProps} error={error} fullWidth={fullWidth} size={size} variant="outlined">
      {label ? <InputLabel id={labelId}>{label}</InputLabel> : null}
      <Select {...props} label={label} labelId={label ? labelId : undefined} size={size}>
        {children}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  )
}
